let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lTapz")).then(() => parcelRequire('2Wlt9'));